import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { MoredetailsRoutingModule } from './moredetails-routing.module';
import { MoredetailsListComponent } from './moredetails-list/moredetails-list.component';
import { MoredetailsCreateComponent } from './moredetails-create/moredetails-create.component';

@NgModule({
  declarations: [MoredetailsListComponent, MoredetailsCreateComponent],
  imports: [
    CommonModule,
    MoredetailsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class MoredetailsModule { }
